import * as React from 'react';
import Pagination from '../Pagination';
import { Pencil, Trash2 } from 'lucide-react';
import { CustomAlertDialog } from '../AlertDialog';
import { RootState } from '@/types';
import { useSelector } from 'react-redux';

import { useDeleteExpanceMutation } from '@/store/expancesApi';
import { toast } from 'sonner';

interface Ledger {
  ledger: string;
  _id: string;
}

interface Expense {
  ledger: Ledger;
  remark?: string;
  amount: number;
  date: string;
  month: string;
  year: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  __v: number;
}

export default function RecentTransactions({
  filterBySearchTerm,
  setIsOpen,
  setEditData,
}) {
  const [deleteEx, { isSuccess: deleteSuccess }] = useDeleteExpanceMutation();
  const { user } = useSelector((state: RootState) => state.user);
  const handleDelete = (id) => {
    deleteEx({
      expanseId: id,
      Token: user?.token,
    });
  };

  const handleEdit = (item) => {
    setIsOpen(true);
    setEditData(item);
  };

  React.useEffect(() => {
    if (deleteSuccess) {
      toast.success('Expanse delete Success');
    }
  }, [deleteSuccess]);

  return (
    <div className="overflow-x-auto">
      <Pagination data={filterBySearchTerm} itemsPerPage={10}>
        {(paginatedData) => (
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 font-semibold text-gray-600">
                  Date
                </th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">
                  Category
                </th>
                <th className="text-left py-3 px-4 font-semibold text-gray-600">
                  Description
                </th>
                <th className="text-right py-3 px-4 font-semibold text-gray-600">
                  Amount
                </th>
                <th className="text-center py-3 px-4 font-semibold text-gray-600">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData?.map((item: Expense, index) => (
                <tr
                  key={index}
                  className="border-b border-muted hover:bg-muted"
                >
                  <td className="py-3 px-4">
                    {new Date(item.date).toLocaleDateString('en-IN', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                    })}
                  </td>
                  <td className="py-3 px-4">{item?.ledger?.ledger}</td>
                  <td className="py-3 px-4">{item?.remark}</td>
                  <td className="py-3 px-4 text-right">₹{item?.amount}</td>
                  <td className="pl-6 py-4 whitespace-nowrap text-sm ">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(item)}
                        className="p-1 rounded-full hover:bg-blue-50 text-blue-600 transition-all duration-300 transform hover:scale-110"
                      >
                        <Pencil className="w-4 h-4" />
                      </button>
                      <CustomAlertDialog
                        title="Delete Expanse"
                        description={
                          <>
                            Are you sure you want to delete the expense
                            <span className="font-semibold text-primary">
                              {' '}
                              "{item?.ledger?.ledger}"{' '}
                            </span>
                            with a remark
                            <span className="font-semibold text-primary">
                              {' '}
                              "{item?.remark}"{' '}
                            </span>
                            amounting to
                            <span className="font-semibold text-primary">
                              {' '}
                              ₹{item?.amount}{' '}
                            </span>
                            ?
                            <br />
                            <br /> *The amount will be deducted from the total
                            expenses.
                          </>
                        }
                        onConfirm={() => handleDelete(item?._id)}
                        triggerButton={
                          <button className="p-1 rounded-full hover:bg-red-50 text-red-600 transition-all duration-300 transform hover:scale-110">
                            <Trash2 className="w-4 h-4" />
                          </button>
                        }
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Pagination>
    </div>
  );
}
